import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function CryptoBlockchainLicenseMalta (){

    return (
        <main className='main'>

            <SEO
                title="Malta Crypto License | VFA Act EU Blockchain Regulation "
                description="Get a Malta VFA crypto license for exchanges, wallets, token issuance, and blockchain projects. MFSA-regulated EU framework with global recognition. "
                keywords="Malta crypto license, VFA license Malta, MFSA crypto regulation, crypto exchange license Malta, blockchain license EU, token issuance Malta, crypto wallet license Malta, DeFi licensing Malta"
                url="/crypto-blockchain-license-malta"
            />

            <IntroSection
                title="Crypto & Blockchain License – Malta (VFA Act)"
                subtitle="Operate Your Crypto Business with EU Recognition"
                description={`
                    <b>Malta</b> is a <b>global leader</b> in <b>crypto and blockchain regulation</b>, having introduced the <b>Virtual Financial Assets Act (VFA)</b> in <b>2018</b>. This made <b>Malta</b> one of the <b>first jurisdictions</b> to regulate <b>crypto exchanges</b>, <b>custodians</b>, <b>token issuers</b>, and <b>blockchain-based businesses</b> under a <b>dedicated legal framework</b>.
                    Supervised by the <b>Malta Financial Services Authority (MFSA)</b>, a <b>Maltese crypto license</b> is <b>globally recognized</b> and grants <b>strong banking and PSP acceptance within the EU</b>.
                `}
                badges={
                    [
                        "Crypto Exchanges",
                        "Wallets & Custodians",
                        "VFA Advisors",
                        "Token Issuance",
                        "DeFi & Blockchain Projects"
                    ]
                }
                buttonText="Request a Malta Crypto Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Malta for Crypto?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "EU Credibility",
                                            text: "Tier-1 recognition for crypto exchanges and VASPs."
                                        },
                                        {
                                            title: "MFSA Regulated",
                                            text: "Aligned with EU AMLD5/AMLD6 directives and FATF standards."
                                        },
                                        {
                                            title: "Comprehensive Framework",
                                            text: "Covers advisory, brokerage, exchanges, custody, and token offerings."
                                        },
                                        {
                                            title: "Banking & PSP Access",
                                            text: "Higher acceptance compared to offshore regulators."
                                        },
                                        {
                                            title: "Institutional Trust",
                                            text: "Attracts VC, PE, and strategic partners."
                                        }
                                    ]
                            }
                        ]}
                    />


                    <InfoBlocks
                        title="Classes of VFA Licenses (MFSA)"
                        blocks={[
                            {
                                title: 'Class 1 VFA License',
                                items:
                                    [
                                        {
                                            title: "Advisory Services",
                                            text: "Advisory services on crypto assets."
                                        },
                                        {
                                            title: "Client Assets",
                                            text: "No handling of client assets."
                                        },
                                        {
                                            title: "Capital Requirement",
                                            text: "€50,000."
                                        }
                                    ]
                            },
                            {
                                title: "Class 2 VFA License",
                                items:
                                    [
                                        {
                                            title: "Execution & Brokerage",
                                            text: "Execution of client orders, brokerage services."
                                        },
                                        {
                                            title: "Client Funds",
                                            text: "Cannot hold client money or assets."
                                        },
                                        {
                                            title: "Capital Requirement",
                                            text: "€125,000."
                                        }
                                    ]
                            },

                            {
                                title: "Class 3 VFA License",
                                items:
                                    [
                                        {
                                            title: "Execution & Custody",
                                            text: "Execution of orders + custody of client assets."
                                        },
                                        {
                                            title: "Activities Allowed",
                                            text: "Market making and portfolio management allowed."
                                        },
                                        {
                                            title: "Capital Requirement",
                                            text: "€730,000."
                                        }
                                    ]
                            },
                            {
                                title: "Class 4 VFA License",
                                items:
                                    [
                                        {
                                            text: "Full crypto exchange license (CEX/DEX)."
                                        },
                                        {
                                            text: "Operate trading platforms for crypto/virtual assets."
                                        },
                                        {
                                            text: "Can hold custody and client money."
                                        },
                                        {
                                            title: "Capital Requirement",
                                            text: "€730,000."
                                        }
                                    ]
                            },
                        ]}
                    />


                    <LocationTimeline
                        title="Benefits of a Malta Crypto License"
                        item={
                            [
                                {
                                    title: "Global Recognition",
                                    text: "One of the most prestigious crypto frameworks."
                                },
                                {
                                    title: "EU Passporting",
                                    text: "Future-proof for EU MiCA regulation."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Stronger banking access than offshore centers (Anjouan, Mwali, Western Sahara)."
                                },
                                {
                                    title: "Compliance-Oriented",
                                    text: "Attracts institutional investors & partnerships."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "Regulated status enhances company valuation."
                                }
                            ]
                        }
                    />
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Define business model and class of license."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register a Maltese entity."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Business plan, AML/KYC manuals, governance."
                                },
                                {
                                    title: "MFSA Review",
                                    text: "Detailed compliance and due diligence checks."
                                },
                                {
                                    title: "Systems Audit & Testing",
                                    text: "Technical evaluation of platform infrastructure."
                                },
                                {
                                    title: "License Approval",
                                    text: "Typically 6–12 months."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–12 months.",
                            },
                            {
                                name: "Setup Cost",
                                description: "from €70,000+ (legal, compliance, advisory fees).",
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "Competitive vs Malta/Estonia",
                            },
                            {
                                name: "Capital Requirement",
                                description: "€50,000–€730,000 depending on license class.",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Experts in EU crypto licensing & compliance."
                                },
                                {
                                    text: "Guidance on selecting VFA Class 1–4 licenses."
                                },
                                {
                                    text: "End-to-end service: incorporation, compliance, application filing."
                                },
                                {
                                    text: "Partnerships with crypto-friendly banks, PSPs, and EMIs."
                                },
                                {
                                    text: "Support for token offerings, DeFi platforms, and NFT projects."
                                }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA
                        title="Looking for Tier-1 credibility in crypto?"
                        description="Malta offers one of the most comprehensive EU crypto frameworks, making it the perfect jurisdiction for exchanges, wallets, and token projects."
                        buttonText="Book a Malta Crypto License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Malta still a top choice for crypto?",
        content: [
            { type: "answer", text: "Yes — Malta’s VFA Act remains one of the most respected frameworks, and it aligns with EU MiCA rules." },
        ],
    },
    {
        question: "What is the difference between Class 3 and Class 4 licenses?",
        content: [
            { type: "answer", text: "Class 3 = custody & market making, but no exchange.\nClass 4 = full crypto exchange license." },
        ],
    },
    {
        question: "What are the capital requirements?",
        content: [
            { type: "answer", text: "€50k (Class 1) up to €730k (Class 3/4)." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–12 months depending on complexity." },
        ],
    },
    {
        question: "Does Malta support DeFi and token projects?",
        content: [
            { type: "answer", text: "Yes — STOs, ICOs, DeFi, and NFT projects can operate under the VFA framework." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We obtained a Malta Class 4 crypto exchange license with Offshore Advisory. The process was strict but gave us EU credibility.",
            author: "Alex P.",
            role: "Exchange CEO"
        },
        {
            quote: "Our blockchain advisory firm licensed under Class 1 VFA. Offshore Advisory handled compliance and MFSA reporting.",
            author: "Sofia M.",
            role: "Crypto Advisor"
        }
    ]
;